/* import __COLOCATED_TEMPLATE__ from './detect-duplicate-conversations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();